import { ClientMatterContactDetails } from './../../core/models/client-matter-contact-details';
import { MatterService } from './../../core/services/matter.service';
import { Component, Input, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DateTime } from 'luxon';
import { ActivityService } from '../../core/services/activity.service';
import { Activity } from '../../core/models/activity';
import { from, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClientService } from '../../core/services/client.service';

@Component({
  selector: 'app-activity-list',
  templateUrl: './activity-list.component.html',
  styleUrl: './activity-list.component.scss',
})
export class ActivityListComponent implements OnInit {

  @Input() matterId: string | undefined;

  loading = true;
  DateTime = DateTime;

  clientMatterContactDetails : ClientMatterContactDetails | undefined;

  activities: Activity[] = [];
  defaultColumns: string[] = ['fileDesc', 'completeBy', 'completed'];
  dataSource = new MatTableDataSource(this.activities);
  displayedColumns = this.defaultColumns;
  ureadActivities: any;

  constructor(private activityService: ActivityService, private matterService: MatterService, private clientService : ClientService) { }

  ngOnInit(): void {
    this.getActivities()
  }


  // We should only show activities IF:
  // 1. The client is not matter based and the matterId is undefined
  // 2. The client is matter based and the matterId is defined
  // Otherwise, we should hide the activities
  activitiesShouldBeVisible(): boolean {

      return this.clientMatterContactDetails?.isMatterBased == (this.matterId != undefined);
  }

  getActivities() {

    this.loading = true;
    this.activities = [];
    var observable;
    if (this.matterId) {
      observable = this.matterService.getActivities(this.matterId);
    }
    else {
      observable = this.activityService.getActivities();
    }

    observable.subscribe({
      next: (activityResult: Activity[]) => {
        this.activities = activityResult;
        this.dataSource = new MatTableDataSource(this.activities);
        this.loading = false;
      },
      error: (error: any) => { this.loading = false; }
    })

  }

  refreshActivities() {
    this.getActivities();
  }


  getDueDateClass(element: Activity): string {

    const ExpiredClass = "expired";
    const ExpiringClass = "expiring";
    // Warn if the activity is due in the next 7 days
    const WarningDays = 7;

    if (element.completed || !element.completeBy) {
      return "";
    }

    var dueDate = DateTime.fromISO(element.completeBy);
    if (dueDate < DateTime.now()) {
      return ExpiredClass;
    }
    if (dueDate.diffNow('days').days < WarningDays) {
      return ExpiringClass;
    }
    return "";
  }


}
